module.exports = {"id":"54013","name":"Stewart Downing","rating":"72","photo":"./data/images/photos/1/54013.png","club":{"name":"Middlesbrough","logo":"./data/images/clubs/Middlesbrough.png"},"positions":["MG","MD","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StewartDowning0.json
// module id = 4044
// module chunks = 0